export class RegistroDocumentacion{
    codigoSucursal: number;
    sucursal: string;
    codigoRamo: number;
    ramo: string;
    numeroPoliza: string;
    numeroDocumento: string;
    apellido: string;
    fechaEmision: string;
    dias: number;
    color: string;
    codigoProceso: number;
    codigoDocumento: number;
    documentacionCargada: boolean;

    constructor(codigoSucursal: number, sucursal: string, codigoRamo: number, ramo: string,
                numeroPoliza: string, numeroDocumento: string, apellido: string,
                fechaEmision: string, dias: number, color: string, codigoProceso: number, documentacionCargada: boolean){
        this.codigoSucursal=codigoSucursal;
        this.sucursal=sucursal;
        this.codigoRamo=codigoRamo;
        this.ramo=ramo;
        this.numeroPoliza=numeroPoliza;
        this.numeroDocumento=numeroDocumento;
        this.apellido=apellido;
        this.fechaEmision=fechaEmision;
        this.dias=dias;
        this.color=color;
        this.codigoProceso=codigoProceso;
        this.documentacionCargada=documentacionCargada;
    }
}